import type { ExtractPropTypes } from 'vue'

export const tabPaneProps = {
  /**
   * 标签标题
   */
  label: {
    type: String,
    default: ''
  },
  /**
   * 标签名称，唯一标识
   */
  name: {
    type: [String, Number],
    default: ''
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 是否延迟渲染
   */
  lazy: {
    type: Boolean,
    default: false
  },
  /**
   * 标签是否可关闭
   */
  closable: {
    type: Boolean,
    default: null
  }
} as const

export type TabPaneProps = ExtractPropTypes<typeof tabPaneProps>